import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import type { CalendarEvent } from 'src/meetings/models';

export const useAddEventParticipant = (eventId: string) => {
  const queryClient = useQueryClient();

  return useMutation<{ data: CalendarEvent }, Error, { clientId: string }>({
    mutationFn: ({ clientId }) =>
      api.post<CalendarEvent>(`calendar-events/${eventId}/participants`, {
        participantType: 'CLIENT',
        clientId,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['calendar-events', eventId] });
    },
  });
};
